import React from 'react';
import { CheckmarkFilled } from '@fluentui/react-icons';
import { Label, Text } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';

const BoardingProgress = ({ currentProgressStep }) => {

  const { t, i18n } = useTranslation();
  const steps = [1, 2, 3];

  const getStepStatus = (step) => {
    if (step < currentProgressStep) return 'completed';
    if (step === currentProgressStep) return 'active';
    return 'upcoming';
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        width: "70%",
        margin: "20px auto",
        position: "relative",
      }}
    >
      {steps.map((step, index) => (
        <div key={step} style={{ position: "relative", textAlign: "center" }}>
          {/* Progress Bar */}
          {index < steps.length - 1 && (
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "100%",
                transform: "translateY(-50%)",
                width: "450px", 
                height: "4px",
                backgroundColor:
                  getStepStatus(step) === "completed" ? "#0078D4" : "#e1eff0",
                zIndex: 0,
              }}
            ></div>
          )}
          <div
            style={{
              width: 40,
              height: 40,
              borderRadius: "50%",
              backgroundColor:
                getStepStatus(step) === "completed"
                  ? "#0078D4"
                  : getStepStatus(step) === "active"
                    ? "#0078D4"
                    : "white",
              color: getStepStatus(step) === "active" ? "white" : "white",
              border: "2px solid #0078D4",
              cursor: "pointer",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1,
            }}
          >
            {getStepStatus(step) === "completed" ? (
              <CheckmarkFilled styles={{ fontSize: 16 }} />
            ) : (
              <Text variant="mediumPlus" style={{ color: getStepStatus(step) === "active" ? "white" : "black", }}>{step}</Text>
            )}
          </div>

          <div
            style={{
              position: "absolute",
              width: i18n.language === "th" ? "150px" : "200px",
              left: i18n.language === "th" ? "-52px" : "-75px",
              top: "120%",
              fontWeight: "bolder",
              paddingTop: "5px",
              paddingBottom: "5px",
            }}
          >
            <Label weight="semibold" style={{
              color: getStepStatus(step) === "completed"
                ? "#4A4A4A"
                : getStepStatus(step) === "active"
                  ? "#4A4A4A"
                  : "grey",
            }} >
              {(() => {
                switch (step) {
                  case 1:
                    return t('boarding.selectDocumentTemplates');
                  case 2:
                    return t('boarding.fillCompanyData');
                  case 3:
                    return t('boarding.setupComplete');
                  default:
                    return "";
                }
              })()}
            </Label>
          </div>
        </div>
      ))}
    </div>
  );
};


export default BoardingProgress;
